export default "__VITE_ASSET__BEbgSaxx__"